import { RTKTags, api } from '@/store/api'

import Env from '../../../env/env'

import type {
  ImpersonationReportResponse,
  ImpersonationScreeningResponse,
  ImpersonationSearchStatusResponse,
  StartImpersonationSearchResponse,
} from './Impersonation.types'

export const impersonationApi = api.injectEndpoints({
  endpoints: (builder) => ({
    // useRunImpersonationScreeningMutation
    runImpersonationScreening: builder.mutation<
      ImpersonationScreeningResponse,
      void
    >({
      query: () => ({
        url: `${Env.BASE_API_URL}/api/v1/impersonation/screening`,
        method: 'POST',
      }),
    }),

    // useStartImpersonationSearchMutation
    startImpersonationSearch: builder.mutation<
      StartImpersonationSearchResponse,
      void
    >({
      query: () => ({
        url: `${Env.BASE_API_URL}/api/v1/impersonation/search`,
        method: 'POST',
      }),
      invalidatesTags: [RTKTags.userInfo, RTKTags.historyAccount],
    }),

    // useLazyGetImpersonationSearchStatusQuery
    getImpersonationSearchStatus: builder.query<
      ImpersonationSearchStatusResponse,
      { id: string }
    >({
      query: ({ id }) => ({
        url: `${Env.BASE_API_URL}/api/v1/impersonation/search/${id}/status`,
        method: 'GET',
      }),
    }),

    // useGetImpersonationReportQuery
    getImpersonationReport: builder.query<
      ImpersonationReportResponse,
      { id: string }
    >({
      query: ({ id }) => ({
        url: `${Env.BASE_API_URL}/api/v1/impersonation/reports/${id}`,
        method: 'GET',
      }),
    }),
  }),
})

export const {
  useRunImpersonationScreeningMutation,
  useStartImpersonationSearchMutation,
  useLazyGetImpersonationSearchStatusQuery,
  useGetImpersonationReportQuery,
} = impersonationApi
